import { useContext, useEffect, useRef, useState } from 'react'
import Button from '../../common/Button'
import InputText from '../../common/InputText'
import LinkWithStatus from '../../common/LinkWithStatus'
import { createSearchParams, useParams } from 'react-router-dom'
import { NavContext } from '../../../context/global_context'
import { deleteRequest, getRequest } from '../../../services/base'
import {
  DeviceConnectionContext,
  SET_DEVICE_CONNECTION_DATA,
  SET_SELECTED_DEVICE_CONNECTION_DATA,
  SET_SHOW_HIDE_DEVICE_CONNECTION_POPUP,
} from './context/context'
import DeviceConnectionsRow from './DeviceConnectionsRow'
import NoRecordsFound from '../../common/NoRecordsFound'
import Pagination from '../../common/Pagination'
import DeviceConnectionForm from './form'
import { getSessionStorageData } from '../../../utils/SessionStorage'

const DeviceConnections = () => {
  let { vehicle } = useParams()

  const [navState, navDispatch] = useContext(NavContext)
  const [state, dispatch] = useContext(DeviceConnectionContext)
  const [searchValue, setSearchValue] = useState('')

  const vehicle_redirect_url = getSessionStorageData('vehicle')?.search
    ? `/vehicles/?${createSearchParams(getSessionStorageData('vehicle'))}`
    : `/vehicles`
  const currentUrl = useRef(
    `/api/device_connection/?vehicle=${vehicle}&search=${searchValue}`
  )

  useEffect(() => {
    navDispatch({
      type: 'header',
      data: {
        header: vehicle,
        sub_header: 'Device Connections',
        id: '',
        show_back_btn: true,
        dtc_details: {},
        back_btn_url: vehicle_redirect_url,
        full_width_container: false,
      },
    })
    getDeviceConnectionsData()
  }, [])

  const getDeviceConnectionsData = async () => {
    navDispatch({
      type: 'loader',
      data: {
        caption: 'Fetching Devices Data',
        showLoader: true,
      },
      notification: {},
    })
    let res = await getRequest(currentUrl.current)
    dispatch({
      type: SET_DEVICE_CONNECTION_DATA,
      data: { data: res.results, pagination: res.pagination },
    })
    navDispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
  }

  const deleteDeviceConnections = async (device_connection) => {
    if (
      window.confirm(
        `Are you sure want to delete, It will delete all existing mappings`
      ) === true
    ) {
      let res = await deleteRequest(
        `/api/device_connection/${device_connection?.id}/?vehicle=${vehicle}`
      )
      if (res?.status) {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: `Device Connections Successfully deleted!`,
          },
        })
        setTimeout(() => {
          getDeviceConnectionsData()
        }, 100)
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: `Something went wrong!`,
          },
        })
      }
    }
  }

  const onDataSave = (status, msg) => {
    if (status) {
      getDeviceConnectionsData()
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: msg,
        },
      })
    } else {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: msg,
        },
      })
    }
  }

  return (
    <div className="w-full">
      <DeviceConnectionForm
        onDataSave={(status, msg) => {
          onDataSave(status, msg)
        }}
      />

      <form
        className="flex flex-col w-full space-y-2 pb-2"
        acceptCharset="UTF-8"
        onSubmit={(e) => {
          e.preventDefault()
        }}
      >
        <div
          className={`flex space-x-5 justify-between content-center items-center`}
        >
          <div className="flex items-center w-1/2">
            <div className="flex items-center w-full">
              <InputText
                name="search_value"
                placeholder={`Search Devices`}
                className={`w-100`}
                value={searchValue}
                isFullSize={true}
                type="search"
                onChange={(value) => {
                  setSearchValue(value)
                }}
                isRequired={false}
                wrapperClass={`pl-0`}
              />
              <Button
                className={`cursor-pointer btn my-4 justify-end`}
                text={`Search`}
                onClick={() => {
                  currentUrl.current = `/api/device_connection/?vehicle=${vehicle}&search=${searchValue}`
                  getDeviceConnectionsData()
                }}
              />
            </div>
          </div>
          <div className="w-6/12 flex font-light text-center space-x-5 justify-end content-center items-center">
            <LinkWithStatus
              href={`/administration/device_connections/new`}
              className={
                'cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded'
              }
              title="Create New Device Connections"
              onClickFunc={() => {
                dispatch({
                  type: SET_SHOW_HIDE_DEVICE_CONNECTION_POPUP,
                  data: true,
                })
              }}
            />
          </div>
        </div>
      </form>

      <div className="font-light">
        <div className="flex flex-row w-full bg-tracer-lt-blue rounded-t-lg text-white px-3 text-sm">
          <div className="flex w-3/12 items-center">Device Name</div>
          <div className="flex w-4/12 pl-6 items-center">Signal Name</div>
          <div className="flex w-2/12 pl-6 items-center">Pin From</div>
          <div className="flex w-2/12 pl-6 items-center">Pin To</div>
          <div className="flex w-1/12 pl-6 items-center"></div>
        </div>
      </div>

      {state?.data?.data.map((device_connection, index) => {
        return (
          <DeviceConnectionsRow
            {...device_connection}
            onDelete={() => {
              deleteDeviceConnections(device_connection)
            }}
            key={`device-connection-${index}`}
            onShowDetails={() => {
              dispatch({
                type: SET_SELECTED_DEVICE_CONNECTION_DATA,
                data: { ...device_connection, index: index },
              })
            }}
          />
        )
      })}

      {state?.data?.data?.length < 1 && (
        <NoRecordsFound
          caption={'Device Connections Data not found'}
          loading={false}
        />
      )}

      <div className="py-6">
        <Pagination
          context={state?.data?.pagination}
          onClickNext={(e) => {
            currentUrl.current = e
            getDeviceConnectionsData()
          }}
          onClickPrev={(e) => {
            currentUrl.current = e
            getDeviceConnectionsData()
          }}
        />
      </div>
    </div>
  )
}

export default DeviceConnections
